class ContactHeader extends HTMLElement {
  constructor() {
    super();

    this.contentSwitchers = this.querySelectorAll(".content-switcher");
    this.init();
  }

  init() {
    this.contentSwitchers.forEach((switchbtn) => {
      switchbtn.addEventListener("click", this.switchClick.bind(this));
    });
  }

  switchClick(event) {
    const currentSwitcher = event.target;
    const sectionType = currentSwitcher.dataset.sectionType;
    const prevActiveSwitcher = this.querySelector(".content-switcher.active");
    const prevActiveSectionType = prevActiveSwitcher.dataset.sectionType;

    if(prevActiveSectionType && prevActiveSectionType === sectionType) {
      return;
    } else {
      prevActiveSwitcher ? prevActiveSwitcher.classList.remove("active") : "";
      currentSwitcher.classList.add("active");

      prevActiveSectionType ? document.querySelector(`.${prevActiveSectionType}`).classList.remove("show-contents") : "";
      document.querySelector(`.${sectionType}`).classList.add("show-contents");
    }
  }
}

customElements.define("contact-header", ContactHeader);
